<template>
  <el-drawer
    :before-close="closeDrawer"
    :visible.sync="showFlag"
    direction="rtl"
    custom-class="demo-drawer"
    size="53%"
    ref="drawer"
    :with-header="false"
  >
    <div class="drawer-steps-body">
      <h-module-head
        slot="title"
        :titleInfo="titleInfo"
        :showBar="false"
        heightPx="80"
        titleSize="24px"
        iconEl="el-icon-close"
        borderB="1px solid #EFEFEF"
        @clickEvent="closeDrawer"
      ></h-module-head>
      <div class="drawer-content-steps">
        <ul class="steps-x">
          <li class="steps-module" v-for="(item, index) in stepsArr" :key="index">
            <div class="steps-body">
              <i class="el-icon-circle-check" style="font-size: 30px; color: #17A48B" v-if="stepIndex > index + 1"></i>
              <div
                class="steps-number"
                v-else
                :style="{
                  color: stepIndex > index + 1 ? '#222222' : stepIndex == index + 1 ? '#ffffff' : '#999999',
                  background: stepIndex > index + 1 ? '#17A48B' : stepIndex == index + 1 ? '#17A48B' : '#ffffff',
                  border: stepIndex > index + 1 ? '' : '1px solid #BEBEBE',
                }"
              >
                {{ index + 1 }}
              </div>
              <div class="steps-content" :style="{ color: stepIndex > index + 1 ? '#222222' : '#999999' }">
                <div class="steps-title">第{{ item.steps }}步</div>
                <div class="steps-describe">{{ item.stepsName }}</div>
              </div>
            </div>
            <div class="steps-divider" v-if="index != stepsArr.length - 1">
              <div></div>
            </div>
          </li>
        </ul>
      </div>
      <div class="drawer-content-info">
        <el-form ref="addStudtentform" :model="applyInfo" class="create-form" v-if="stepIndex < stepsArr.length">
          <template v-for="(item, i) in stepsData[stepIndex - 1]">
            <el-form-item :key="i" v-if="item.type == 'input'">
              <div class="form-item">
                <div class="form-item-name" :style="{ width: labelWidth }">{{ item.label }}：</div>
                <el-input
                  v-model="applyInfo[item.key]"
                  :type="item.textarea ? 'textarea' : 'text'"
                  :rows="item.textareaRow ? item.textareaRow : 5"
                  :maxlength="item.textareaNum ? item.textareaNum : 100"
                  :show-word-limit="item.textarea"
                  :placeholder="item.placeholder ? item.placeholder : '请输入'"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item :key="i" v-if="item.type == 'datePicker'">
              <div class="form-item">
                <div class="form-item-name" :style="{ width: labelWidth }">{{ item.label }}：</div>
                <el-date-picker
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00', '23:59:59']"
                  :picker-options="validTimeOption"
                  v-model="applyInfo[item.key]"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  range-separator="至"
                ></el-date-picker>
              </div>
            </el-form-item>
            <el-form-item :key="item.label" v-if="item.type == 'select'">
              <div class="form-item">
                <div class="form-item-name" :style="{ width: labelWidth }">{{ item.label }}：</div>
                <el-select
                  v-model="applyInfo[item.key]"
                  :placeholder="item.placeholder ? item.placeholder : '请选择'"
                  :multiple="item.multiple"
                  @change="selectChange($event, item)"
                >
                  <el-option v-for="(info, n) in item.options" :label="info.label" :value="info.value" :key="n"></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item :key="i" v-if="item.type == 'cascader'">
              <div class="form-item">
                <div class="form-item-name" :style="{ width: labelWidth }">{{ item.label }}：</div>
                <el-cascader
                  :show-all-levels="item.showAll == 'false' ? false : true"
                  :props="{ checkStrictly: item.showAll == 'false' ? false : true, multiple: item.checkAll == 'true' ? true : false }"
                  clearable
                  v-model="applyInfo[item.key]"
                  :placeholder="item.placeholder ? item.placeholder : '请选择'"
                  :options="item.options"
                  :key="i"
                ></el-cascader>
              </div>
            </el-form-item>
            <el-form-item :key="i" v-if="item.type == 'group'">
              <div class="form-item">
                <div class="form-item-name" :style="{ width: labelWidth }">{{ item.label }}：</div>
                <el-radio-group v-model="applyInfo[item.key]">
                  <el-radio v-for="(info, n) in item.options" :key="n" :label="info.value">{{ info.label }}</el-radio>
                </el-radio-group>
              </div>
            </el-form-item>
          </template>
        </el-form>
        <template v-if="stepIndex == stepsArr.length">
          <div class="drawer-content-overflow">
            <template v-for="(item, i) in applyList">
              <div class="drawer-contentItems-body" :key="i">
                <div class="drawer-info-title">
                  <div class="title-divider title-divider-color"></div>
                  <div class="title-name" :style="{ width: labelWidth }">{{ item.label }}</div>
                </div>
                <div class="contentItems-info" v-if="item.value.length > 0">
                  <div class="contentItems-info-item" style="width: 50%; height: auto" v-for="(info, index) in item.value" :key="index">
                    <div class="contentItems-ii-title">{{ info.label }}</div>
                    <div class="contentItems-ii-content">{{ info.value }}</div>
                  </div>
                  <div class="div-border-top" :style="{ width: item.value.length > 1 ? '100%' : '50%' }"></div>
                </div>
              </div>
            </template>
          </div>
        </template>
      </div>
      <div class="drawer-bottom-button">
        <button class="bottom-cancel-button" style="margin-right: 16px" @click="closeDrawer">取消</button>
        <button class="bottom-cancel-button" style="margin-right: 16px" @click="backStep">上一步</button>
        <button class="bottom-sure-button" @click="nextStep" v-show="stepIndex < stepsArr.length">下一步</button>
        <button class="bottom-sure-button" @click="submit" v-show="stepIndex == stepsArr.length">发布</button>
      </div>
    </div>
  </el-drawer>
</template>

<script>
/*
步骤信息
stepsArr:[
  {
    steps:'一',
    stepsName:'基础信息'
  }
]
stepsData:{
  0:[
    {
      type:'',//输入类型：input,datePicker,select,cascader,group
      label:'',//form名称
      key:'',//字段的key值
      placeholder:'',//提示,
      options:[]//选项： select,cascader,group使用
      multiple:true,//是否多选：select使用
      defaultValue:'',//默认值：可以是字符串或者数组等,还用于判断是否选择了默认值，若是则不让选其他的选项
      textarea:true,//input使用
      textareaRow:5,//input使用
      maxlength:100,//input使用
      require:false,//是否必选
      //后续补充联动函数
    }
  ]
}
apiName: {
  submit: 'saveJoinArmy',
},

typeName: {
  key: 'planClassId',
      value: '2001'
},
conditions:{
  submit:{
    planClassId:'3001'
  }
}
*/
import hModuleHead from './h-module-head.vue'
export default {
  components: { hModuleHead },
  props: {
    showFlag: {
      type: Boolean,
      default: false,
    }, //是否打开抽屉
    titleInfo: {
      type: String,
      default: '',
    }, //抽屉标题
    stepsArr: {
      type: Array,
      default: () => {
        return []
      },
    }, //引导分步数据
    stepsData: {
      type: Object,
      default: () => {
        return {}
      },
    }, //引导输入数据（此对象中的属性的数量要比分步的数组的长度少一个）
    apiName: {
      type: Object,
    }, //接口名
    typeName: {
      type: String, //调用抽屉的类型，可用于特殊判断
    },
    conditions: {
      type: Object, //特殊条件
    },
    labelWidth: {
      type: String,
      default: '180px',
    }, // label宽度
  },
  data() {
    return {
      stepIndex: 1,
      applyInfo: {}, //申请信息
      applyList: [], //预览页面数据
      validTimeOption: {
        disabledDate(date) {
          return date.getTime() < new Date().getTime() - 86400000
        },
      },
    }
  },
  mounted() {},
  watch: {
    showFlag(val) {
      if (val) {
        console.log('this.stepsData ', this.stepsData)
        for (const key in this.stepsData) {
          console.log('key', key)
          this.stepsData[key].forEach((item) => {
            if (undefined != item.defaultValue) {
              this.$set(this.applyInfo, item.key, item.defaultValue)
              console.log('this.applyInfo:', this.applyInfo)
            }
          })
        }
      }
    },
  },
  methods: {
    //用于限制下拉框选择了全部不让选择其他的选项
    selectChange(val, item) {
      if (undefined != item.defaultValue && item.type == 'select' && item.multiple) {
        if (val.length > 1 && val.indexOf(item.defaultValue[0]) !== -1) {
          this.$set(this.applyInfo, item.key, item.defaultValue)
        }
      }
    },
    //下一步判断
    nextStep() {
      let flag = false
      let name = ''
      if (this.stepIndex < this.stepsArr.length) {
        this.stepsData[this.stepIndex - 1].forEach((item) => {
          console.log('item:', item)
          if (item.require) {
            if ((item.key == 'select' && item.multiple) || item.key == 'cascader' || item.key == 'datePicker') {
              if (!this.applyInfo[item.key] || this.applyInfo[item.key].length == 0) {
                flag = true
                name = item.label
                return
              }
            } else {
              if (!this.applyInfo[item.key] || '' == this.applyInfo[item.key] || null == this.applyInfo[item.key]) {
                flag = true
                name = item.label
                return
              }
            }
          }
        })

        if (flag) {
          this.$message({
            message: name + '还未填写或选择！',
            duration: 3000,
            type: 'warning',
          })
          return
        } else {
          this.stepIndex += 1
        }
      }

      if (this.stepIndex == this.stepsArr.length) {
        console.log('-----------发布')
        //按分步处理数据
        this.stepsArr.forEach((item, index) => {
          if (index < this.stepsArr.length - 1) {
            let obj = {
              label: item.stepsName,
              value: [],
            }
            //通过数据的类型来处理数据
            this.stepsData[index].forEach((info) => {
              let map = {}
              map['label'] = info.label
              if (info.type == 'select' && info.multiple) {
                let title = ''
                info.options.forEach((fe) => {
                  this.applyInfo[info.key].forEach((param, i) => {
                    if (param == fe.value) {
                      title = title + fe.label + '、'
                    }
                  })
                })
                map.value = title.substr(0, title.length - 1)
                obj.value.push(map)
              } else if (info.type == 'datePicker') {
                map['value'] = this.applyInfo[info.key][0] + '~' + this.applyInfo[info.key][1]
                obj.value.push(map)
              } else if (info.type == 'select') {
                info.options.forEach((fe) => {
                  if (fe.value == this.applyInfo[info.key]) {
                    map['value'] = fe.label
                  }
                })
                obj.value.push(map)
              } else if (info.type == 'cascader') {
                // 级联未验证后续有需求的话可以改成闭包的形式调用
                // 寝室划分传的级联是老接口其他地方没有级联 新接口可能不适用
                let title = ''
                if (this.applyInfo[info.key].length > 0) {
                  info.options.forEach((fe) => {
                    if (fe.value == this.applyInfo[info.key][index][0]) {
                      title = fe.label
                      if (this.applyInfo[info.key][index].length > 1) {
                        fe.children.forEach((cl) => {
                          if (cl.value == this.applyInfo[info.key][index][1]) {
                            title = title + '、' + cl.label
                            if (this.applyInfo[info.key][index].length > 2) {
                              cl.children.forEach((ch) => {
                                if (ch.value == this.applyInfo[info.key][index][2]) {
                                  title = title + '、' + ch.label
                                  title = ch.label
                                }
                              })
                            }
                          }
                        })
                      }
                    }
                  })
                  map['value'] = title
                  obj.value.push(map)
                }
              } else {
                map.value = this.applyInfo[info.key]
                obj.value.push(map)
              }
            })
            this.applyList.push(obj)
          }
        })
      }
    },
    backStep() {
      if (this.stepIndex == this.stepsArr.length) {
        this.applyList = []
      }
      if (this.stepIndex > 1) {
        this.stepIndex -= 1
      }
    },
    submit() {
      console.log(' this.applyInfo:', this.applyInfo)
      let data = {}
      for (const key in this.applyInfo) {
        if (typeof this.applyInfo[key] == 'boolean') {
          data[key] = this.applyInfo[key]
        } else if ('' != this.applyInfo[key] && null != this.applyInfo[key]) {
          if (key == 'dateGroup') {
            data['startTime'] = this.applyInfo[key][0]
            data['endTime'] = this.applyInfo[key][1]
          } else if (key == 'buildings') {
            data[key] = []
            this.applyInfo[key].forEach((ele)=>{
              data[key].push(ele[2])
            })
          } else {
            data[key] = this.applyInfo[key]
          }
        }
      }
      //特殊条件
      // console.log('JSON.stringify(this.conditions):', JSON.stringify(this.conditions), JSON.stringify(this.conditions.submit))
      if (this.conditions && JSON.stringify(this.conditions) != '{}' && JSON.stringify(this.conditions.submit) != '{}') {
        for (const key in this.conditions.submit) {
          data[key] = this.conditions.submit[key]
        }
      }
      console.log('data:', data)
      this.$API[this.apiName.submit](data).then((res) => {
        console.log('saveTicket:', res)
        if (res.code == '10000') {
          this.$message({
            message: '创建成功！',
            duration: 3000,
            type: 'success',
          })
          this.closeDrawer()
        } else {
          this.$message({
            message: res.message,
            duration: 3000,
            type: 'error',
          })
        }
      })
    },
    closeDrawer() {
      this.stepIndex = 1
      this.applyInfo = {}
      this.applyList = []
      this.$emit('close')
    },
  },
}
</script>
<style lang="less" scoped>
.displayFlex {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.drawer-steps-body {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;

  .drawer-content-steps {
    width: 100%;
    height: 86px;
    background: linear-gradient(180deg, #ffffff 0%, #f2f2f2 100%);

    .steps-x {
      // .displayFlex;
      // justify-content: space-around;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      overflow-x: auto;
      overflow-y: hidden;
      width: 100%;
      height: 100%;
      .steps-module {
        width: 300px;
        height: 100%;
        // flex: 1;
        .displayFlex;
        justify-content: flex-start;
        padding-left: 60px;
        flex-shrink: 0;
        .steps-body {
          height: 100%;
          .displayFlex;
          .steps-number {
            width: 30px;
            height: 30px;
            background: #17A48B;
            border-radius: 50%;
            .displayFlex;
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #ffffff;
          }
          .steps-content {
            margin-left: 10px;
            .steps-title {
              font-size: 18px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #222222;
              margin-bottom: 6px;
            }
            .steps-describe {
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #222222;
            }
          }
        }
        .steps-divider {
          height: 100%;
          flex: 1;
          .displayFlex;
          padding-left: 60px;
          & > div {
            width: 100%;
            height: 0px;
            border: 1px dashed #bebebe;
          }
        }
      }
    }
  }
  .drawer-content-info {
    padding: 40px 60px 86px 60px;
    .displayFlex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    justify-content: flex-start;
    overflow-y: auto;

    .create-form {
      width: 100%;
      .form-item {
        display: flex;
        align-items: center;

        .form-item-name {
          font-size: 18px !important;
          font-family: PingFang SC;
          font-weight: 400;
          color: #222222;
          width: 180px;
          text-align: right;
          margin-right: 10px;
          // letter-spacing: 10px;
        }
      }
      .el-form-item__content {
        width: calc(100% - 180px) !important;
      }
      .el-select {
        width: calc(60%) !important;
        // height: 60px;
      }
      .el-input {
        width: calc(60%) !important;
        // height: 60px;
      }
      .el-cascader {
        width: calc(60%) !important;
        // height: 50px;
      }
      .el-textarea {
        width: calc(60%) !important;
      }
      .el-input__inner {
        width: calc(60%) !important;
        // height: 50px;
        // line-height: 50px;
      }
      .el-form--inline .el-form-item {
        width: 49%;
        margin-right: 0px !important ;
      }
    }
    .drawer-content-overflow {
      height: 100%;
      overflow-y: auto;
      width: 100%;
      .drawer-contentItems-body {
        width: 100%;
        border: 1px;
        margin-bottom: 20px;
        .drawer-info-title {
          .displayFlex;
          position: relative;
          height: 58px;
          width: 100%;
          background: #ffffff;
          .title-divider {
            left: 0;
          }

          .title-name {
            position: absolute;
            left: 12px;
            font-size: 20px;
            font-family: PingFang SC;
            font-weight: 600;
            color: #2b2f3f;
          }
          .title-right{
            font-size: 24px;
          }
        }
        .contentItems-info {
          box-sizing: border-box;
          display: flex;
          flex-wrap: wrap;
          width: 100%;
          // border-top: 1px solid #d0d0d0;
          border-left: 1px solid #d0d0d0;
          position: relative;
          .contentItems-info-item {
            box-sizing: border-box;
            border-right: 1px solid #d0d0d0;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            height: 40px;
            .contentItems-ii-title {
              width: 31%;
              height: 100%;
              .displayFlex;
              background: #f5f5f5;
              border-right: 1px solid #d0d0d0;
              border-bottom: 1px solid #d0d0d0;
              flex-wrap: wrap;
              padding: 10px;
              text-align: center;
            }

            .contentItems-ii-content {
              flex: 1;
              .displayFlex;
              justify-content: flex-start;
              padding: 10px 10px;
              height: 100%;
              border-bottom: 1px solid #d0d0d0;
              flex-wrap: wrap;
            }
          }

          .div-border-top {
            content: '';
            position: absolute;
            top: 0px;
            left: 0;
            height: 1px;
            background-color: #d0d0d0;
          }
        }
      }
    }
  }
  .drawer-bottom-button {
    .displayFlex;
    justify-content: flex-end;
    padding-right: 60px;
    width: 100%;
    height: 76px;
    position: absolute;
    bottom: 0;
    right: 0;
  }
}
.steps-x::-webkit-scrollbar {
  display: none;
}

</style>



// WEBPACK FOOTER //
// src/components/parts/h-drawer-steps.vue